import {
  APP_STORE_URL,
  PLAY_GOOGLE_URL,
  STORAGE_INVITATION_EMAIL_EVENT_TRACKING,
} from 'config/constants';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Api from 'api/api';
import { TrackEventRequest } from 'api/interfaces/request';
import {
  TrackEventCategoryEnum,
  TrackEventTypeEnum,
} from 'config/TrackEventType';

export const DownloadApp = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get('code');
  const src = queryParams.get('src');
  const action = queryParams.get('action');

  const hasRun = sessionStorage.getItem(
    STORAGE_INVITATION_EMAIL_EVENT_TRACKING,
  );

  const trackEvent = async (event: TrackEventRequest) => {
    try {
      await Api.eventTracking(event);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Error tracking event:', error);
    }
  };

  const eventType =
    action === 'button'
      ? TrackEventTypeEnum.INVITATION_EMAIL_DOWNLOAD_APP_BUTTON_CLICKED
      : TrackEventTypeEnum.INVITATION_EMAIL_DOWNLOAD_APP_QR_CODE_SCANNER;

  useEffect(() => {
    if (hasRun || !code || !src || !action) return;

    const payload: TrackEventRequest = {
      eventCategory: TrackEventCategoryEnum.INVITATION_EMAIL,
      eventType,
      eventDate: `${new Date().toISOString()}`,
      entityId: code,
      details: {
        src,
        action,
      },
    };

    trackEvent(payload);
    sessionStorage.setItem(STORAGE_INVITATION_EMAIL_EVENT_TRACKING, 'true');

    return () => {
      sessionStorage.removeItem(STORAGE_INVITATION_EMAIL_EVENT_TRACKING);
    };
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Some legacy browsers expose window.opera; treat it as unknown
    const userAgent =
      navigator.userAgent ||
      (window as unknown as { opera?: string })?.opera ||
      '';

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.location.href = APP_STORE_URL;
    } else if (/android/i.test(userAgent)) {
      window.location.href = PLAY_GOOGLE_URL;
    } else {
      navigate('/join-program');
    }
  }, []);

  return null; // Empty page
};
